class ProductBundle {
  constructor() {
    // Elements
    this.packOptions = document.querySelectorAll('.pack-option');
    this.flavorItems = document.querySelectorAll('.flavor-item');
    this.purchaseOptions = document.querySelectorAll('.purchase-options');
    this.subscriptionSelect = document.querySelector('.subscription-dropdown');
    this.cartButton = document.querySelector('.cart-button');
    this.selectedPack = Array.from(document.querySelectorAll("[data-default-select]")).find(pack => pack.dataset.defaultSelect === "true")?.dataset.packValue;
    this.selectedFlavors = new Map();
    this.isPurchaseSubscription = true;
    this.bundleProducts = window.bundleProducts;
    this.cartNotification = document.querySelector('cart-notification');

    // Store original product images for restoration
    this.originalImages = this.storeOriginalImages();

    this.init();
  }

  init() {
      this.initPackSelection();
      this.initFlavorSelection();
      this.initPurchaseOptions();
      this.initCartButton();
      
      this.initializePriceMappings();
      this.initializeVariantMappings();
      this.initializeSellingPlanMappings();
    
      this.updateCartButtonPrice();
      this.updateReviewCount();

      this.updateMainProductImage();
  }

  initPackSelection() {
    this.packOptions.forEach(pack => {
      pack.addEventListener('click', () => {
        const prevPackSize = parseInt(this.selectedPack);
        const newPackSize = parseInt(pack.querySelector('.pack-size').textContent);
  
        // Update selected visual
        this.packOptions.forEach(p => p.classList.remove('selected'));
        pack.classList.add('selected');
        this.selectedPack = pack.querySelector('.pack-size').dataset.packValue;

        document.querySelectorAll('.subscription-dropdown').forEach(select =>
          select.classList.toggle('hidden', select.dataset.subscriptionPack.toLowerCase() !== this.selectedPack.toLowerCase())
        );
  
        if (newPackSize < prevPackSize) {
          // Clear all flavors if going from higher to lower pack
          this.selectedFlavors.clear();
  
          this.flavorItems.forEach(item => {
            const addButton = item.querySelector('.add-button');
            const quantityContainer = item.querySelector('.flavor-quantity');
            const quantityInput = item.querySelector('.quantity-input');


            if(!addButton.classList.contains("sold-out")) {
              addButton.classList.remove('hidden', 'disabled');
              addButton.removeAttribute('disabled');
            }
  
            quantityContainer.classList.add('hidden');
            quantityInput.value = 0;
          });
        } else {
          // Going from low to high, update .add-button disabled state
          this.updateAddButtonsState();
        }
  
        this.updateCartButtonState();
        this.updateCartButtonPrice();
        this.updateSubscriptionDiscount();
        this.updateMainProductImage();
      });
    });
  }

  initFlavorSelection() {
    this.flavorItems.forEach(item => {
      const addButton = item.querySelector('.add-button');
      const quantityContainer = item.querySelector('.flavor-quantity');
      const quantityInput = item.querySelector('.quantity-input');
      const plusBtn = item.querySelector('.quantity-btn.plus');
      const minusBtn = item.querySelector('.quantity-btn.minus');
      const flavorName = item.querySelector('.flavor-name').dataset.variant;
  
      addButton.addEventListener('click', () => {
        if (this.canAddMoreFlavors()) {
          addButton.classList.add('hidden');
          quantityContainer.classList.remove('hidden');
          this.updateFlavorQuantity(flavorName, 1);
        }
      });
  
      plusBtn.addEventListener('click', () => {
        if (this.canAddMoreFlavors()) {
          this.updateFlavorQuantity(flavorName, parseInt(quantityInput.value) + 1);
        }
      });
  
      minusBtn.addEventListener('click', () => {
        const newQuantity = parseInt(quantityInput.value) - 1;
       
        if (newQuantity === 0) {
          addButton.classList.remove('hidden');
          quantityContainer.classList.add('hidden');
        }
        this.updateFlavorQuantity(flavorName, newQuantity);
      });
  
      item.addEventListener("click", (e) => {
        this.updateVariantImg(e);
      });
    });
  }

  initPurchaseOptions() {
      this.purchaseOptions.forEach(option => {
          option.addEventListener('change', (e) => {
              this.purchaseOptions.forEach(opt => opt.classList.remove('active'));
              option.classList.add('active');
              this.isPurchaseSubscription = option.querySelector('input').value === 'subscription';
              this.updateCartButtonPrice();
              this.updateMainProductImage();
          });
      });
  }

  initializePriceMappings() {
    this.variantPrices = {};
    
    this.bundleProducts.forEach(product => {
      const packSize = product.packSize;
      const regularPriceInCents = Number(product.pricing.base.originalPrice); // price in cents
      const basePriceInCents = Number(product.pricing.base.price); // price in cents
      const subscriptionDiscount = Number(product.pricing.subscription.discount); // discount in %
      const onetimeDisount = Number(product.onetimeDiscount); // discount in %
      const oneTimeDiscEligible = (product.onetimeDiscount) ? true : false;
      const additionalDiscount = Number(product.pricing.additionalDiscount.discount); // discount in %

    
      if (isNaN(basePriceInCents) || isNaN(subscriptionDiscount)) {
        console.warn("Invalid base price or discount for pack size:", packSize);
        return;
      }
    
      // Calculate subscription price
      const discountAmount = (basePriceInCents * subscriptionDiscount) / 100;
      const onetimeDiscountAmount = (basePriceInCents * onetimeDisount) / 100;

      const onetimeDiscountedPriceInCents = Math.round(basePriceInCents - onetimeDiscountAmount);
      const onetimeComparePrice = (onetimeDiscountedPriceInCents / 100).toFixed(2);
      
      const discountedPriceInCents = Math.round(basePriceInCents - discountAmount);
      const subscriptionPrice = (discountedPriceInCents / 100).toFixed(2);

      const regularDiscountAmount = (regularPriceInCents * subscriptionDiscount) / 100;
      const subscriptionPriceInCents = Math.round(regularPriceInCents - regularDiscountAmount);
      const subscriptionRegularPrice = (subscriptionPriceInCents / 100).toFixed(2);
    
      // Format base and compare prices
      const basePrice = (basePriceInCents / 100).toFixed(2);
      const regularPrice = (regularPriceInCents / 100).toFixed(2);


      const RegularDiscountAmnt = (regularPriceInCents * onetimeDisount) / 100;
      const onetimePriceInCents = Math.round(regularPriceInCents - RegularDiscountAmnt);
      const onetimeRegularPrice = (onetimePriceInCents / 100).toFixed(2);


      // Format additional discount prices
      const additionalDiscountAmount = (basePriceInCents * additionalDiscount) / 100;
      const additionalDiscountedPriceInCents = Math.round(basePriceInCents - additionalDiscountAmount);
      const additionalComparePrice = (additionalDiscountedPriceInCents / 100).toFixed(2);


      this.variantPrices[packSize] = {
        base: {
          originalPrice: (regularPriceInCents / 100).toFixed(2),
          price: basePrice,
          comparePrice: onetimeComparePrice,
          oneTimeDiscEligible: oneTimeDiscEligible,
          regularPrice: onetimeRegularPrice
        },
        subscription: {
          originalPrice: (regularPriceInCents / 100).toFixed(2),
          price: subscriptionPrice,
          comparePrice: basePrice,
          discount: subscriptionDiscount,
          regularPrice: subscriptionRegularPrice
        },
        additionalDiscount: {
          discount: additionalDiscount,
          comparePrice: additionalComparePrice
        }
      };
    });
  }

  initializeVariantMappings() {
    this.variantMap = {};
    
    this.bundleProducts.forEach(product => {
        const packSize = product.packSize;
        
        if (!this.variantMap[packSize]) {
            this.variantMap[packSize] = {};
        }

        product.variants.forEach(variant => {
            const flavorName = variant.title;
            this.variantMap[packSize][flavorName] = variant.id;
            
            // Store normalized version for case-insensitive matching
            const normalizedFlavorName = flavorName.toLowerCase().replace(/[^a-z0-9]/g, '');
            this.variantMap[packSize][normalizedFlavorName] = variant.id;
        });
    });
  }

  initializeSellingPlanMappings() {
    this.frequencyMap = {};
    
    this.bundleProducts.forEach(product => {
        if (product.selling_plan_groups.length > 0) {
            product.selling_plan_groups[0].selling_plans.forEach(plan => {
                const frequency = plan.name.split('(')[0].trim();
                this.frequencyMap[frequency] = plan.id;
            });
        }
    });
  }

  updateVariantImg(event) {
      if (!event.target.matches("[data-add-button]") && !event.target.matches(".quantity-btn")) {
          document.querySelectorAll(".flavor-item").forEach(ele => ele.classList.remove("active"));
          event.currentTarget.classList.add("active");

          let imgSrc = event.currentTarget.dataset.sliderImg;
          const mainSliderImage = document.querySelector('.product__media-list .product__media-item img');
          const thumbSliderImage = document.querySelector('.thumbnail-list .thumbnail-list__item img');
          const modelImg = document.querySelector("product-modal .global-media-settings");

          if (mainSliderImage) {
              mainSliderImage.srcset = imgSrc;
              mainSliderImage.src = imgSrc;
          }

          if (thumbSliderImage) {
              thumbSliderImage.srcset = imgSrc;
              thumbSliderImage.src = imgSrc;
          }

          if (modelImg) {
              modelImg.srcset = imgSrc;
              modelImg.src = imgSrc;
          }
          console.log(document.querySelectorAll(".thumbnail-slider .thumbnail-list__item")[0], "listtt");
          document.querySelectorAll(".thumbnail-slider .thumbnail-list__item")[0].querySelector("button").click();
      }
  }

  updateAddButtonsState() {
    const packSize = parseInt(this.selectedPack);
    let totalQuantity = 0;
  
    this.selectedFlavors.forEach(qty => totalQuantity += qty);
  
    this.flavorItems.forEach(item => {
      const addBtn = item.querySelector('.add-button');
      const flavorName = item.querySelector('.flavor-name').textContent;
  
      if (this.selectedFlavors.has(flavorName)) return;  
      if (totalQuantity >= packSize) {
        if(!addBtn.classList.contains("sold-out")) {
          addBtn.classList.add('disabled');
          addBtn.setAttribute('disabled', 'disabled');
        }
      } else {
        if(!addBtn.classList.contains("sold-out")) {
          addBtn.classList.remove('disabled');
          addBtn.removeAttribute('disabled');
        }
      }
    });
  }
  

  updateFlavorQuantity(flavorName, quantity) {
    const flavorItem = this.flavorItems[Array.from(this.flavorItems)
      .findIndex(item => item.querySelector('.flavor-name').dataset.variant === flavorName)];
    
    const quantityInput = flavorItem.querySelector('.quantity-input');
    const addButton = flavorItem.querySelector('.add-button');
    const quantityContainer = flavorItem.querySelector('.flavor-quantity');
    
    quantityInput.value = quantity;
    this.selectedFlavors.set(flavorName, quantity);
    
    // Update UI based on pack size
    const packSize = parseInt(this.selectedPack);
    let totalQuantity = 0;
    this.selectedFlavors.forEach((qty) => {
      totalQuantity += qty;
    });
    
    // Disable add buttons if pack size is reached
    this.flavorItems.forEach(item => {
      const addBtn = item.querySelector('.add-button');
      const qtyContainer = item.querySelector('.flavor-quantity');
      const flavorName = item.querySelector('.flavor-name').textContent;
      
      if(packSize != 3) {
        if (totalQuantity >= packSize) {
          if(!addBtn.classList.contains("sold-out")) {
            addBtn.classList.add('disabled');
            addBtn.setAttribute('disabled', 'disabled');
          }
        } else {
          if(!addBtn.classList.contains("sold-out")) {
            addBtn.classList.remove('disabled');
            addBtn.removeAttribute('disabled');
          }
        }
      } else {
        addBtn.classList.remove('disabled');
        addBtn.removeAttribute('disabled');
      }
    });
    
    this.updateCartButtonState();
    this.updateCartButtonPrice();
  }

  canAddMoreFlavors() {
    const packSize = parseInt(this.selectedPack);
    let totalQuantity = 0;
    
    this.selectedFlavors.forEach((quantity) => {
      totalQuantity += quantity;
    });

    if (packSize === 3) {
      return true;
    }
    
    return totalQuantity < packSize;
  }

  updateSubscriptionDiscount() {
    const selectedProduct = this.bundleProducts.find(product => 
      product.packSize === this.selectedPack
    );
    let subscriptionDiscount = selectedProduct.FixedDiscount;
    document.querySelector("[data-sub-discount]").innerText = `SAVE ${subscriptionDiscount}%`;
  }

  updateCartButtonPrice() {
    // const selectedProduct = this.bundleProducts.find(product =>
    //   product.packSize === this.selectedPack
    // ); new code here by gpt
    let selectedProduct = this.bundleProducts.find(product =>
      product.packSizes.includes(this.selectedPack) &&
      product.variants.some(variant => {
        const qty = this.selectedFlavors.get(String(variant.id));
        return qty > 0;
      })
    );
    if(selectedProduct == undefined){
      selectedProduct = this.bundleProducts.find(product =>
      product.packSizes.includes(this.selectedPack)
    );
    }

    const packSize = this.selectedPack.split(" ")[0];

    this.updateMainProductImage();

    const onetimeAmount = this.variantPrices[this.selectedPack].base.price * packSize;
    const subscriptionAmount = this.variantPrices[this.selectedPack].subscription.price * packSize;
    // console.log(onetimeAmount, subscriptionAmount);
    const savings = onetimeAmount - subscriptionAmount;
    
    if (!selectedProduct) return;
  
    let totalPrice = 0;
    let hasSelectedFlavors = false;
    let totalQuantity = 0;
    this.selectedFlavors.forEach((quantity) => {
        totalQuantity += quantity;
    });

  
    this.selectedFlavors.forEach((quantity, flavorName) => {
      if (quantity > 0) {
        hasSelectedFlavors = true;
  
        const variant = selectedProduct.variants.find(
          v => v.id.toString() === flavorName.toString()
        );
  
        if (variant) {
          const price = this.isPurchaseSubscription
            ? this.variantPrices[this.selectedPack].subscription.regularPrice
            : this.variantPrices[this.selectedPack].base.regularPrice;
          totalPrice = price * totalQuantity;
        }
        
      }
    });
  
    const basePrice = this.variantPrices[this.selectedPack].base.price * packSize;
  
    // Update subscription price display
    document.querySelectorAll('.price-container.sub-price [data-original-price]')
      .forEach(el => el.textContent = `$${basePrice}`);
  
    // Update one-time price display based on discount eligibility
    if (this.variantPrices[this.selectedPack].base.oneTimeDiscEligible) {
      document.querySelectorAll('.price-container.one-time-price [data-original-price]')
        .forEach(el => el.textContent = `$${basePrice}`);
    } else {
      document.querySelectorAll('.price-container.one-time-price [data-original-price]')
        .forEach(el => el.textContent = ``);
    }


    // Update calculated prices
    const subscriptionPrice = this.variantPrices[this.selectedPack].subscription.price * packSize;
    const onetimePrice = this.variantPrices[this.selectedPack].base.comparePrice * packSize;
    const additionalDiscount = this.variantPrices[this.selectedPack].additionalDiscount.comparePrice * packSize;
    
  
    
    document.querySelectorAll('[data-subscription-price]')
      .forEach(el => el.textContent = `$${subscriptionPrice}`);

    document.querySelectorAll('[data-onetime-price]')
      .forEach(el => el.textContent = `$${onetimePrice}`);

    document.querySelectorAll('[data-additional-discount-price]')
      .forEach(el => el.textContent = `$${additionalDiscount}`);
  
    if(packSize == 3) {
      if(totalQuantity >= packSize) {
        const subscriptionPrice = this.variantPrices[this.selectedPack].subscription.regularPrice * totalQuantity;
        let originalPrice = this.variantPrices[this.selectedPack].base.originalPrice * totalQuantity;
        const flatDiscount = 34;
        const onetimePrice = originalPrice - flatDiscount;
        const comparePrice = this.variantPrices[this.selectedPack].base.originalPrice * totalQuantity;
        const additionalDiscountPrice = originalPrice - (originalPrice * (this.variantPrices[this.selectedPack].additionalDiscount.discount / 100));

        if(!this.isPurchaseSubscription) {
          totalPrice = originalPrice - flatDiscount;
        }
        
        document.querySelectorAll('[data-subscription-price]')
          .forEach(el => el.textContent = `$${subscriptionPrice.toFixed(2)}`);
      
        document.querySelectorAll('[data-onetime-price]')
          .forEach(el => el.textContent = `$${onetimePrice.toFixed(2)}`);

        document.querySelectorAll('.price-container [data-original-price]')
          .forEach(el => el.textContent = `$${comparePrice.toFixed(2)}`);

        document.querySelectorAll('[data-additional-discount-price]')
          .forEach(el => el.textContent = `$${additionalDiscountPrice.toFixed(2)}`);
      }
    }
    // Update cart button text
    this.cartButton.textContent = hasSelectedFlavors
      ? `ADD TO BASKET - $${totalPrice.toFixed(2)}`
      : 'ADD TO BASKET';
  
    // Update dynamic savings text
    const savingsText = `Additional $${Math.round(savings)} Off`;
  
    document.querySelector('[data-saving-text]').textContent = savingsText;
  
    // Toggle visibility of savings text based on subscription toggle
    const savingsContainer = document.querySelector("[data-saving-text]").closest("li");
  
    if (!this.isPurchaseSubscription) {
      savingsContainer.classList.add("hidden");
    } else {
      savingsContainer.classList.remove("hidden");
    }
  }
  

  initCartButton() {
      this.cartButton.addEventListener('click', (event) => this.addToCart(event));
  }

  updateCartButtonState() {
      let totalQuantity = 0;
      const remainingQtyEl = document.querySelector(".remaining_qty");
      const packSize = this.selectedPack.split(" ")[0];
      this.selectedFlavors.forEach((quantity) => {
          totalQuantity += quantity;
      });
      const totalQty = parseInt(totalQuantity);
      const pack = parseInt(packSize);

      if (totalQty > 0) {
        this.updateCartButtonPrice();
      } 
      
      if (totalQty === pack || (pack === 3 && totalQty >= pack)) {
        this.cartButton.classList.remove('disabled');
        this.cartButton.removeAttribute('disabled');
      } else {
        this.cartButton.classList.add('disabled');
        this.cartButton.setAttribute('disabled', 'disabled');
        this.cartButton.textContent = 'ADD TO BASKET';
      }

      if (totalQty > 0) {
        if (pack !== 3) {
          remainingQtyEl.classList.add("hidden");
        }
        if (totalQty < pack) {
          const remainingQty = pack - totalQty;
          const _s = remainingQty == 1 ? '': 's';
          remainingQtyEl.textContent = `Select ${remainingQty} more scent${_s}`;
          remainingQtyEl.classList.remove("hidden");
        } else {
          remainingQtyEl.classList.add("hidden");
        }
      } else {
        remainingQtyEl.classList.add("hidden");
      }
  }
  async addToCart(event) {
    const button = event.currentTarget; 
      try {
          button.setAttribute("disabled", "disabled");
          const items = [];
          let totalQuantity = 0;
          const baseUniqueId = `m${Math.random().toString(36).substr(2, 9)}`;

          this.selectedFlavors.forEach((quantity) => {
              totalQuantity += quantity;
          });

          const selectedFrequency = this.subscriptionSelect.value;
          const sellingPlanId = this.isPurchaseSubscription ?  this.getSellingPlanId(selectedFrequency) : null;
          const selectedProduct = this.bundleProducts.find(product => 
              product.packSize === this.selectedPack
          );

          if (!selectedProduct) {
              throw new Error('Selected product not found');
          }
          // console.log(this.selectedFlavors, 'mdddd');
          this.selectedFlavors.forEach((quantity, flavorName) => {
              if (quantity > 0) {
                  const variant = Number(flavorName);//selectedProduct.variants.find(v => v.id.toString() == flavorName.toString());
                  if (!variant) {
                      return;
                      throw new Error(`Variant not found for flavor: ${flavorName}`);
                  }
                  items.push({
                      id: variant,
                      quantity: quantity,
                      selling_plan: sellingPlanId,
                      properties: {
                        "_bundle_items": true,
                        '_unique_id': baseUniqueId
                      }
                  });
              }
          });

          const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
          });
          // console.log(button, "currr");
          button.removeAttribute("disabled");

          if (!response.ok) throw new Error('Failed to add to cart');
          
          window.location.href = '/cart';
           // Open sidecart and update it
          //  if (window.openSidecart) {
          //   window.openSidecart();
          //   if (window.fetchCart) window.fetchCart();
          // }

      } catch (error) {
          console.error('Error adding to cart:', error);
      }
  }

  normalize(text) {
    return text
      .toLowerCase()
      .replace(/\(.*?\)/g, "") // remove anything inside parentheses
      .trim();
  }

  // getSellingPlanId(frequency) {
  //     const selectedProduct = this.bundleProducts.find(product => 
  //         product.packSize === this.selectedPack
  //     );

  //     if (!selectedProduct) {
  //         console.error('Selected product not found for pack size:', this.selectedPack);
  //         return null;
  //     }

  //     // Check if the product has selling plan groups
  //     if (!selectedProduct.selling_plan_groups || selectedProduct.selling_plan_groups.length === 0) {
  //         console.error('No selling plan groups found for product:', selectedProduct.id);
  //         return null;
  //     }

  //     // Get the first selling plan group (assuming there's only one)
  //     const sellingPlanGroup = selectedProduct.selling_plan_groups;
      
  //     const sellingPlan = sellingPlanGroup.filter((sellingPlanGroupItem) => {
  //       const match = sellingPlanGroupItem.selling_plans.find((plan) => {
  //         if (this.normalize(plan.name).includes(this.normalize(frequency))) {
  //           return true;
  //         }
  //         return false;
  //       });
      
  //       return match !== undefined;
  //     });

  //     if (!sellingPlan) {
  //         return null;
  //     }
  //     let sellingPlanID = sellingPlan[0].selling_plans[0].id;

  //     return sellingPlanID;
  // }

  getSellingPlanId(frequency) {
    
    let sellingPlanID = "";
    document.querySelectorAll('.subscription-dropdown').forEach((dropdown) => {
      if(!dropdown.classList.contains("hidden")) {
        sellingPlanID = dropdown.value;
      }
    });
    // console.log(sellingPlanID,"sellingPlanID");

    return sellingPlanID;
  }
  updateReviewCount() {
    let getReviewWidget = setInterval(() => {
      if(document.querySelector("#stamped-main-widget .stamped-container")) {
        let allReviewCnt = document.querySelector("#stamped-main-widget .stamped-container .stamped-summary-text").dataset.count;
        document.querySelector(".review-count u").textContent = `${allReviewCnt} Reviews`;
        document.querySelector(".review-count").addEventListener("click", () => {
          document.querySelector("#stamped-main-widget .stamped-container").scrollIntoView({
            behavior: 'smooth'
          });
        });
        document.querySelector("[data-all-review-rating]").classList.remove("hidden");
        clearInterval(getReviewWidget);
      }
    }, 1);
  }

  updateMainProductImage() {
    try {
      // Get the current pack size and purchase type
      const packSize = this.selectedPack.split(" ")[0]; // "1", "2", or "4"
      const purchaseType = this.isPurchaseSubscription ? "subscription" : "one_time";
      
      // If it's 1 Pack, restore the original image
      if (packSize === "1") {
        // console.log('1 Pack selected - restoring original product image');
        this.restoreOriginalImages();
        return;
      }
      
      // Create the key for the image lookup
      const imageKey = `${packSize}pk_${purchaseType}`;
      
      // Get the image URL from the bundle addon images
      const imageUrls = window.bundleAddonImages && window.bundleAddonImages[imageKey];
      
      if (imageUrls) {
        // console.log('Updating main product image to:', imageUrls);
        // Update main slider images
        const mainSliderImages = document.querySelectorAll('.product__media-list .product__media-item img');
        mainSliderImages.forEach((img, index) => {
          if (imageUrls[index]) {
            img.srcset = imageUrls[index];
            img.src = imageUrls[index];
          }
        });

        // Update thumbnail slider images
        const thumbSliderImages = document.querySelectorAll('.thumbnail-list .thumbnail-list__item img');
        thumbSliderImages.forEach((img, index) => {
          if (imageUrls[index]) {
            img.srcset = imageUrls[index];
            img.src = imageUrls[index];
          }
        });

        // Update modal images
        const modalImages = document.querySelectorAll('product-modal .global-media-settings img, product-modal .global-media-settings');
        modalImages.forEach((img, index) => {
          if (imageUrls[index]) {
            img.srcset = imageUrls[index];
            img.src = imageUrls[index];
          }
        });
        
      } else {
        console.log('No image found for key:', imageKey, '- keeping current image unchanged');
      }
    } catch (error) {
      console.log('Error updating main product image:', error, '- keeping current image unchanged');
    }
  }

  storeOriginalImages() {
    const originalImages = {};
    
    // Store main slider images
    const mainSliderImages = document.querySelectorAll('.product__media-list .product__media-item img');
    if (mainSliderImages.length > 0) {
      originalImages.mainSlider = [];
      mainSliderImages.forEach(img => {
        originalImages.mainSlider.push({
          src: img.src,
          srcset: img.srcset
        });
      });
    }

    // Store thumbnail slider images
    const thumbSliderImages = document.querySelectorAll('.thumbnail-list .thumbnail-list__item img');
    if (thumbSliderImages.length > 0) {
      originalImages.thumbSlider = [];
      thumbSliderImages.forEach(img => {
        originalImages.thumbSlider.push({
          src: img.src,
          srcset: img.srcset
        });
      });
    }

    // Store modal images
    const modalImages = document.querySelectorAll('product-modal .global-media-settings');
    if (modalImages.length > 0) {
      originalImages.modal = [];
      modalImages.forEach(img => {
        originalImages.modal.push({
          src: img.src,
          srcset: img.srcset
        });
      });
    }

    
    // console.log('Original images stored:', originalImages);
    return originalImages;
  }

  restoreOriginalImages() {
    if (!this.originalImages) {
      // console.log('No original images stored to restore');
      return;
    }
    
    // Restore main slider images
    const mainSliderImages = document.querySelectorAll('.product__media-list .product__media-item img');
    if (mainSliderImages.length > 0 && this.originalImages.mainSlider) {
      mainSliderImages.forEach((img, index) => {
        if (this.originalImages.mainSlider[index]) {
          img.src = this.originalImages.mainSlider[index].src;
          img.srcset = this.originalImages.mainSlider[index].srcset;
        }
      });
    }

    // Restore thumbnail slider images
    const thumbSliderImages = document.querySelectorAll('.thumbnail-list .thumbnail-list__item img');
    if (thumbSliderImages.length > 0 && this.originalImages.thumbSlider) {
      thumbSliderImages.forEach((img, index) => {
        if (this.originalImages.thumbSlider[index]) {
          img.src = this.originalImages.thumbSlider[index].src;
          img.srcset = this.originalImages.thumbSlider[index].srcset;
        }
      });
    }

    // Restore modal images
    const modalImages = document.querySelectorAll('product-modal .global-media-settings');
    if (modalImages.length > 0 && this.originalImages.modal) {
      modalImages.forEach((img, index) => {
        if (this.originalImages.modal[index]) {
          img.src = this.originalImages.modal[index].src;
          img.srcset = this.originalImages.modal[index].srcset;
        }
      });
    }

    
    // console.log('Original images restored');
  }
}

// Initialize the bundle when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductBundle();
});
